import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../model/Organization";
import { MemberCardPoolsSuccessResponse } from "./api-response/MemberCardPoolsSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { map } from "rxjs/operators";

export class ApiMemberCardPool {
  constructor(private apiEndpoint: string) {}

  listForOrganization(
    token: string,
    organization: OrganizationKeyName
  ): Observable<MemberCardPoolsSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/member-card-pools`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
